/**
 * Quantity picker (PDP) helper
 *
 * The +/- logic itself is handled by the theme's <quantity-selector> / quantity-input elements. This only greys out
 * the "-" button at the minimum and the "+" button at the maximum. Uses event delegation so it keeps working after
 * the theme re-renders the product info on variant change.
 */

const updatePicker = (picker) => {
  const input = picker.querySelector('.qty-picker__input');
  const [minusButton, plusButton] = picker.querySelectorAll('.qty-picker__button');
  if (!input || !minusButton || !plusButton) return;

  const value = parseInt(input.value, 10) || 0;
  const min = parseInt(input.min, 10) || 1;
  const max = input.max ? parseInt(input.max, 10) : Infinity;

  minusButton.disabled = value <= min;
  plusButton.disabled = value >= max;
};

const updateAll = () => document.querySelectorAll('.qty-picker').forEach(updatePicker);

['change', 'input'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    const picker = event.target.closest?.('.qty-picker');
    if (picker) updatePicker(picker);
  });
});

// Variant changes re-render the product info (and quantity rules), so refresh after those too
document.addEventListener('variant:change', () => requestAnimationFrame(updateAll));

updateAll();
